// redux/sagas/dashboardSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getDashboardRequest,
  getDashboardSuccess,
  getDashboardFailure,
  getBirthdayCustomersRequest,
  getBirthdayCustomersSuccess,
  getBirthdayCustomersFailure,
} from "./dashboardSlice";

function fetchDashboardApi() {
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/auth/index`);
}

function* fetchDashboardWorker() {
  try {
    const response = yield call(fetchDashboardApi);
    const data = response.data.data;
    console.log("dashboard details",data)
    yield put(getDashboardSuccess(data));
  } catch (error) {
    yield put(getDashboardFailure(error?.response?.data?.message || error.message));
  }
}

function fetchBirthdayCustomersApi({ range, page, limit ,search}) {
  return axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/v1/auth/getBirthdayCustomersList`,
    {
      params: { range, page, limit,search },
    }
  );
}

function* fetchBirthdayCustomersWorker(action) {
  try {
    const response = yield call(fetchBirthdayCustomersApi, action.payload);
    const data = response.data.data; 
    console.log("birthday customers", data);
    yield put(getBirthdayCustomersSuccess(data));
  } catch (error) {
    yield put(
      getBirthdayCustomersFailure(
        error?.response?.data?.message || error.message
      )
    );
  }
}

export function* dashboardSaga() {
  yield takeLatest(getDashboardRequest.type, fetchDashboardWorker);
  yield takeLatest(getBirthdayCustomersRequest.type, fetchBirthdayCustomersWorker);
}
